<template>
  <form autocomplete="off" v-on:submit.prevent="submit(form)" class="form">
    <div class="flex form-row">
      <div class="col-6">
        <label for="current-password">Current Password <span>*</span></label>
        <input type="password" name="current-password" placeholder="Current Password"
               v-model="form.current_password"
               v-validate="'required'"/>
        <span v-if="errors.has('current-password')">{{ errors.first('current-password') }}</span>
      </div>
    </div>
    <div class="flex form-row">
      <div class="col-6">
        <label for="new-password">Password <span>*</span></label>
        <input type="password" name="password " placeholder="Password" ref="password"
               v-model="form.password"
               v-validate="'required|min:6'" />
        <span v-if="errors.has('password ')">{{ errors.first('password') }}</span>
      </div>
    </div>
    <div class="flex form-row">
      <div class="col-6">
        <label for="new-password-confirm">Confirm Password <span>*</span></label>
        <input type="password" name="new-password-confirm" placeholder="Confirm Password"
               v-model="form.password_confirmation"
               v-validate="'required|confirmed:password'"
               data-vv-as="password" />
        <span v-if="errors.has('password-confirm')">{{ errors.first('password-confirm') }}</span>
      </div>
    </div>
    <div class="flex form-row">
      <button class="body-8" :disabled="pending || errors.any()">Submit</button>
    </div>
  </form>
</template>

<script>
    export default {
        name: "UpdatePasswordForm",
        data() {
            return {
                form: {
                    current_password: '',
                    password: '',
                    password_confirmation: '',
                },
                pending: false,
            }
        },
        methods: {
            submit(form) {
                this.$validator.validateAll().then((valid) => {
                    if (valid) {
                        this.$emit('submit', form);
                    }
                });
            }
        }
    }
</script>

<style scoped>

</style>